import CoffeeDetails from "../Components/CoffeeDetails";

export default function ShowSingle() {
    return (
        <div>
            <CoffeeDetails />
        </div>
    );
};
